<template>
	<h1
		class="landing-title"
		:class="[`landing-title_size_${size}`, { 'landing-title_uppercase': uppercase }]"
		:style="customStyles"
		data-typo-type="title"
		v-html="title"
	></h1>
</template>

<script>
export default {
	name: 'LandingTitle',
	props: {
		title: {
			type: String,
			required: true,
		},

		size: {
			type: String,
			default: 'small',
			validator(v) {
				return ['small', 'medium', 'large', 'xl'].includes(v)
			},
		},

		uppercase: {
			type: Boolean,
			default: false,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-title {
	text-align: center;

	&_size {
		&_small {
			margin: var(--size-12) 0 0;

			font-size: var(--size-18);
			line-height: var(--size-22);
			font-weight: 700;
		}

		&_medium {
			margin: var(--size-12) 0 0;

			font-size: var(--size-22);
			line-height: var(--size-26);
			font-weight: 700;
		}

		&_large {
			margin-bottom: var(--size-16);

			font-size: var(--size-28);
			line-height: var(--size-36);
			font-weight: 700;
			letter-spacing: -0.04rem;
		}

		&_xl {
			margin: var(--size-12) 0 var(--size-16);

			font-size: var(--size-32);
			line-height: normal;
			font-weight: 700;
			letter-spacing: -0.04rem;
		}
	}

	&_uppercase {
		text-transform: uppercase;
	}
}
</style>
